import { apiCall, filterParams } from '../helpers/axios';

class CategoryService {

	static getAll(params) {
		return apiCall().get('/categories', { params: params })
			.then(response => response.data)
	}

	static getAuctionCategories(auctionId, params, cancelToken) {
		params.total = 100;
		return apiCall().get(`/auctions/${auctionId}/categories`, { params: params, cancelToken: cancelToken })
			.then(response => response.data);
	}

	static getOne(categoryId) {
		return apiCall().get(`/categories/${categoryId}`)
			.then(response => response.data);
	}

	static create(auction) {
		return apiCall().post(`/categories`, auction)
			.then(response => response.data);
	}

	static update(categoryId, data) {
		return apiCall().put(`/categories/${categoryId}`, data)
			.then(response => response.data);
	}

	static delete(categoryId) {
		return apiCall().delete(`/categories/${categoryId}`)
			.then(response => response.data);
	}
}

export default CategoryService


// WEBPACK FOOTER //
// ./src/services/category-service.js